import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes} from 'react-router-dom';



import './common/css/font-awesome.min.css';

import Adminprofile from './components/Account/Adminprofile';
import Login from './components/Account/Login';
import Logout from "./components/Account/Logout";
import Setting from "./components/Account/Setting";
import Changepassword from "./components/Account/Changepassword";
import Forgetpassword from "./components/Account/Forgetpassword";
import Resetpassword from "./components/Account/Resetpassword";


import UserList from "./components/User/List";
import UserEdit from "./components/User/Edit";
import UserAdd from "./components/User/Add";
import UserView from "./components/User/View";


import Fontlist from "./components/Fonts/List";
import FontAdd from "./components/Fonts/Add";
import FontEdit from "./components/Fonts/Edit";

import TemplateList from './components/Templates/List';
import TemplateAdd from './components/Templates/Add';
import TemplateEdit from './components/Templates/Edit';

import DashboardList from "./components/Dashboard/List";
import Gallery from "./components/Gallery/Gallery";

import FaqCategoryList from "./components/FaqCategory/List";
import FaqCategoryAdd from "./components/FaqCategory/Add";
import FaqCategoryEdit from "./components/FaqCategory/Edit";

import FaqList from "./components/Faq/List";
import FaqAdd from "./components/Faq/Add";
import FaqEdit from "./components/Faq/Edit";
import FaqImport from "./components/Faq/ImportFaq";


import AiFeedList from "./components/AiFeed/List";
import AiImport from "./components/AiFeed/Import";


import DashboardManagement from "./components/DashboardManagement/List";
import DashboardAdd from "./components/DashboardManagement/Add";
import DashboardEdit from "./components/DashboardManagement/Edit";

// import SubmenuManagement from "./components/SubmenuManagement/List";
// import SubmenuManagementAdd from "./components/SubmenuManagement/Add";
// import SubmenuManagementEdit from "./components/SubmenuManagement/Edit";

import MenuManagement from "./components/MenuManagement/List";
import MenuManagementAdd from "./components/MenuManagement/Add";
import MenuManagementEdit from "./components/MenuManagement/Edit";

import AdvisoryDropdown from "./components/AdvisoryDropdown/List";
import AdvisoryDropdownAdd from "./components/AdvisoryDropdown/Add";
import AdvisoryDropdownEdit from "./components/AdvisoryDropdown/Edit";


import AdvertisementList from "./components/Advertisement/List";
import AdvertisementEdit from "./components/Advertisement/Edit";
import AdvertisementAdd from "./components/Advertisement/Add";

import AdsCategoryList from "./components/AdsCategory/List";
import AdsCategoryAdd from "./components/AdsCategory/Add";
import AdsCategoryEdit from "./components/AdsCategory/Edit";



import GuideList from "./components/Guide/List";
import GuideEdit from "./components/Guide/Edit";
import GuideAdd from "./components/Guide/Add";

import GuideCategoryList from "./components/GuideCategory/List";
import GuideCategoryAdd from "./components/GuideCategory/Add";
import GuideCategoryEdit from "./components/GuideCategory/Edit";
import GuideSubCategoryList from "./components/GuideSubCategory/List";
import GuideSubCategoryAdd from "./components/GuideSubCategory/Add";
import GuideSubCategoryEdit from "./components/GuideSubCategory/Edit";

import PackageList from "./components/Package/List";
import PackageAdd from "./components/Package/Add";
import PackageEdit from "./components/Package/Edit";

import NetworkList from "./components/Network/List";
import StoreList from "./components/Store/List";

import Shortcuticon from "./components/Shortcuticon/List";
import ShortcuticonAdd from "./components/Shortcuticon/Add";
import ShortcuticonEdit from "./components/Shortcuticon/Edit";

import AbusiveWordList from "./components/AbusiveWord/List";
import AbusiveWordAdd from "./components/AbusiveWord/Add";
import AbusiveWordEdit from "./components/AbusiveWord/Edit";

import CHATList from "./components/ChatIcons/List";
import CHATEdit from "./components/ChatIcons/Edit";
import CHATAdd from "./components/ChatIcons/Add";

import RoleList from "./components/Rolemanagement/List";
import RoleEdit from "./components/Rolemanagement/Edit";
import RoleAdd from './components/Rolemanagement/Add';

import UserRoleList from "./components/UserRolemanagement/List";
import UserRoleEdit from "./components/UserRolemanagement/Edit";
import UserRoleAdd from "./components/UserRolemanagement/Add";
import UserRoleView from "./components/UserRolemanagement/View";


import JSONAdd from "./components/Jsonaifeed/Add";
import JSONList from "./components/Jsonaifeed/List";
import JSONView from "./components/Jsonaifeed/View";
import JSONEdit from "./components/Jsonaifeed/Edit";

import NotificationList from "./components/Notification/List";
import PurchaseHistoryList from "./components/PurchaseHistory/List";

import ChatQuestionAIList from "./components/ChatQuestionAI/List";
import ChatQuestionAIAdd from "./components/ChatQuestionAI/Add";
import ChatQuestionAIEdit from "./components/ChatQuestionAI/Edit";

import Themelist from "./components/Themes/List";
import ThemeAdd from "./components/Themes/Add";
import ThemeEdit from "./components/Themes/Edit";

import ThemeColorList from "./components/ThemeColor/List";
import ThemeColorAdd from "./components/ThemeColor/Add";
import ThemeColorEdit from "./components/ThemeColor/Edit";

import MemList from "./components/Membership/List";
import MemEdit from "./components/Membership/Edit";
import MemAdd from "./components/Membership/Add";
import MemView from "./components/Membership/View";

import MembershipCategoryList from "./components/MembershipCategory/List";
import MembershipCategoryAdd from "./components/MembershipCategory/Add";
import MembershipCategoryEdit from "./components/MembershipCategory/Edit";

import NotificationTypeList from "./components/NotificationType/List";
import NotificationTypeAdd from "./components/NotificationType/Add";
import NotificationTypeEdit from "./components/NotificationType/Edit";

import './common/css/custom.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Router>
    <Routes>
      <Route exact path="/" element={<Login />} />
      <Route exact path="/profile" element={< Adminprofile />} />
      <Route path="/logout" element={< Logout />} />
      <Route path="/setting" element={<Setting />} />
      <Route path="/changepassword" element={<Changepassword />} />
      <Route path="/forget_password" element={<Forgetpassword/>} />
      <Route path="/reset_password/:key" element={<Resetpassword/>} />
     
      <Route path="/font-edit/:ID" element={<FontEdit />} />
      <Route path="/fonts" element={<Fontlist />} />
      <Route path="/font-add" element={<FontAdd />} />

      <Route path="/user" element={<UserList/>} />
      <Route path="/user-add" element={< UserAdd/>} />
      <Route path="/user-edit/:ID" element={<UserEdit/>} />
      <Route path="/user-view/:ID" element={<UserView/>} />
      

      <Route path="/templates" element={<TemplateList />} />
      <Route path="/template/add" element={<TemplateAdd/>} />
      <Route path="/templates-edit/:ID" element={<TemplateEdit />} />
      <Route path="/dashboard" element={<DashboardList />} /> 
      
      <Route path="/faqcategory" element={<FaqCategoryList/>} />
      <Route path="/faqcategory-add" element={<FaqCategoryAdd/>} />
      <Route path="/faqcategory-edit/:ID" element={<FaqCategoryEdit/>} />  

      <Route path="/faq" element={<FaqList/>} />
      <Route path="/faq-add" element={<FaqAdd/>} />
      <Route path="/faq-edit/:ID" element={<FaqEdit/>} />
      <Route path="/faq-import" element={<FaqImport/>} />

            
      <Route path="/aifeed" element={<AiFeedList/>} />
      <Route path="/aifeed-import" element={<AiImport/>} />
      

        <Route path="/dashboardmanagement" element={<DashboardManagement/>} />
        <Route path="/dashboardmanagement-edit/:ID" element={<DashboardEdit/>} />
        {/* <Route path="/dashboardmanagement-add" component={<DashboardAdd/>} /> */}
        
      {/* <Route path="/submenumanagement" element={<SubmenuManagement/>} />
      <Route path="/submenumanagement-edit/:ID" element={<SubmenuManagementEdit/>} />
      <Route path="/submenumanagement-add" element={<SubmenuManagementAdd/>} /> */}
      <Route path="/MenuManagement" element={<MenuManagement/>} />
      <Route path="/MenuManagement-edit/:ID" element={<MenuManagementEdit/>} />
      <Route path="/MenuManagement-add" element={<MenuManagementAdd/>} />
      
      <Route path="/AdvisoryDropdown" element={<AdvisoryDropdown/>} />
      <Route path="/AdvisoryDropdown-edit/:ID" element={<AdvisoryDropdownEdit/>} />
      <Route path="/AdvisoryDropdown-add" element={<AdvisoryDropdownAdd/>} />

      <Route path="/advertisement" element={<AdvertisementList/>} />
      <Route path="/advertisement-add" element={<AdvertisementAdd/>} />
      <Route path="/advertisement-edit/:ID" element={<AdvertisementEdit/>} />

      <Route path="/adscategory" element={<AdsCategoryList/>} />
      <Route path="/adscategory-add" element={<AdsCategoryAdd/>} />
      <Route path="/adscategory-edit/:ID" element={<AdsCategoryEdit/>} />
      

      <Route path="/guide" element={<GuideList/>} />
      <Route path="/guide-edit/:ID" element={<GuideEdit/>} />
      <Route path="/guide-add" element={<GuideAdd/>} />

      <Route path="/guidecategory" element={<GuideCategoryList/>} />
      <Route path="/guidecategory-add" element={<GuideCategoryAdd/>} />
      <Route path="/guidecategory-edit/:ID" element={<GuideCategoryEdit/>} /> 

      <Route path="/guidesubcategory" element={<GuideSubCategoryList/>} />
      <Route path="/guidesubcategory-add" element={<GuideSubCategoryAdd/>} />
      <Route path="/guidesubcategory-edit/:ID" element={<GuideSubCategoryEdit/>} />

      <Route path="/package" element={<PackageList/>} />
      <Route path="/package-add" element={<PackageAdd/>} />
      <Route path="/package-edit/:ID" element={<PackageEdit/>} />  
      
      <Route path="/networks" element={<NetworkList/>} />     
      <Route path="/stores" element={<StoreList/>} />     
      
      <Route path="/notifications" element={<NotificationList/>} />     
      <Route path="/purchasehistory" element={<PurchaseHistoryList/>} />   

       <Route path="/shortcuticon/edit/:ID" element={<ShortcuticonEdit/>} />
        <Route path="/shortcuticon" element={<Shortcuticon/>} />
        <Route path="/shortcuticon-add" element={<ShortcuticonAdd/>} />  

        <Route path="/abusiveword-edit/:ID" element={<AbusiveWordEdit/>} />
        <Route path="/abusivewords" element={<AbusiveWordList/>} />
        <Route path="/abusiveword-add" element={<AbusiveWordAdd/>} />

        <Route path="/chat" element={<CHATList/>} />
        <Route path="/chat-edit/:ID" element={<CHATEdit/>} />
        <Route path="/chat-add" element={<CHATAdd/>} /> 

        <Route path="/rolemanagement" element={<RoleList/>} />
        <Route path="/rolemanagement-add" element={<RoleAdd/>} />
        <Route path="/rolemanagement-edit/:ID" element={<RoleEdit/>} />

        <Route path="/userrolemanagement" element={<UserRoleList/>} />
        <Route path="/userrolemanagement-add" element={<UserRoleAdd/>} />
        <Route path="/userrolemanagement-edit/:ID" element={<UserRoleEdit/>} />
        <Route path="/userrolemanagement-view/:ID" element={<UserRoleView/>} />

         <Route path="/json" element={<JSONList/>} />
         <Route path="/json-add" element={<JSONAdd/>} />
         <Route path="/json-view/:ID" element={<JSONView/>} />
         <Route path="/json-edit/:ID" element={<JSONEdit/>} />

        <Route path="/chatquestionai" element={<ChatQuestionAIList/>} />
        <Route path="/chatquestionai-add" element={<ChatQuestionAIAdd/>} />
        <Route path="/chatquestionai-edit/:ID" element={<ChatQuestionAIEdit/>} />  

        <Route path="/themes" element={<Themelist />} />
        <Route path="/theme-add" element={<ThemeAdd />} />
        <Route path="/theme-edit/:ID" element={<ThemeEdit />} />

        <Route path="/themecolor" element={<ThemeColorList/>} />
        <Route path="/themecolor-add" element={<ThemeColorAdd/>} />
        <Route path="/themecolor-edit/:ID" element={<ThemeColorEdit/>} />  

        <Route path="/membership" element={<MemList />} />
        <Route path="/membership-edit/:ID" element={<MemEdit />} />
        <Route path="/membership-view/:ID" element={<MemView />} />
        <Route path="/membership-add" element={<MemAdd />} />

        <Route path="/membershipcategory" element={<MembershipCategoryList />}/>
        <Route path="/membershipcategory-add" element={<MembershipCategoryAdd />}/>
        <Route path="/membershipcategory-edit/:ID" element={<MembershipCategoryEdit />}/>

        <Route path="/notificationtype" element={<NotificationTypeList/>} />
        <Route path="/notificationtype-edit/:ID" element={<NotificationTypeEdit/>} />
        <Route path="/notificationtype-add" element={<NotificationTypeAdd />} />
    </Routes>
  </Router>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
